import React from 'react'
import styled from 'styled-components'

import { flex, colors, media } from '../../constants/style'
import { pages } from '../../constants/site'

import { Column } from '../UI/Grid'
import { BuyButton, ShowMoreButton } from '../UI/Button'
import { RoundImage } from '../UI/Image'

import { getHashedPath, getCategoryFromFields } from '../../utils'
import Nl2br from '../../utils/Nl2br'

import CategoryBall from '../CategoryBall'

const Wrapper = Column.extend`
  padding: 40px;
  flex-basis: 100%;
  flex-wrap: wrap;
  border-bottom: 1px solid ${colors.red};
  ${media.medium`
    border: none;
    flex-basis: 50%;
  `} ${media.large`
    flex-basis: 25%;
  `};
`

const Content = styled(Column).attrs({
  grow: 0,
  shrink: 1,
})`
  padding: 20px 0 0;
`

const ContentTitleSmall = Content.extend`
  margin-bottom: 20px;
  ${media.medium`
    display: none;
  `};
`

const ContentTitleMedium = Content.extend`
  ${media.mediumDown`
    display: none;
  `};
`

const ContentButton = Content.extend`
  flex-basis: auto;
  flex-direction: row;
  ${media.mediumDown`
    order: 2;
  `};
`

const Title = styled.h2`
  color: ${colors.red};
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  margin-bottom: 1em;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

const Subtitle = styled.h3`
  color: ${colors.red};
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
`

const fontStyle = `
  font-size: .8rem;
  line-height: 1rem;
  text-transform: uppercase;
`

const Label = styled.span`
  ${fontStyle}
  color: ${colors.gray};
  font-weight: bold;
`

const Text = styled.span`
  ${fontStyle}
  color: ${colors.gray};
`

const ContentHourText = Text.extend`
  height: 3em;
`

const AImg = styled.a`
  display: inline-flex;
  height: 26px;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`

const EventHomePage = ({ data }) => {
  const {
    node: {
      fields,
      frontmatter: { image, link, showtime, subtitle, title },
    },
  } = data

  const {
    slug,
    category: {
      fields: { slug: categorySlug },
      frontmatter: {
        title: categoryTitle,
        icon: categoryIcon,
        hidden: categoryHidden,
      },
    },
  } = getCategoryFromFields(fields)

  return (
    <Wrapper align={flex.align.CENTER} grow={0}>
      <ContentTitleSmall>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </ContentTitleSmall>

      <Column grow={0}>
        <RoundImage src={image} />
      </Column>

      <Column grow={0} shrink={1}>
        <ContentButton grow={1}>
          <a href={link} target="_blank">
            <BuyButton>Acquista</BuyButton>
          </a>

          {!categoryHidden && (
            <AImg href={getHashedPath(pages.PROGETTI.link, categorySlug)}>
              <CategoryBall src={categoryIcon} alt={categoryTitle} />
            </AImg>
          )}
        </ContentButton>

        <ContentTitleMedium grow={1}>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </ContentTitleMedium>

        <Content>
          <Label>Orario spettacoli</Label>
          <ContentHourText>
            <Nl2br source={showtime} />
          </ContentHourText>
        </Content>

        <Content>
          <a href={getHashedPath(pages.SPETTACOLI.link, slug)}>
            <ShowMoreButton>{'Scopri di più  >>'}</ShowMoreButton>
          </a>
        </Content>
      </Column>
    </Wrapper>
  )
}

export default EventHomePage



// WEBPACK FOOTER //
// ./src/components/EventHomepage/index.js